import React, { useEffect } from 'react';
import config from 'utils/config';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import StoreActions from '../../../../actions/storeActions';
import AlertRenderer from '../../../shared/alertRenderer';
import LanguageSwitcher from './LanguageSwitcher';
import useRedirectAfterLogin from './useRedirectAfterLogin';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AuthPageWrapper(_ref) {
  var children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 396 : _ref$width;
  useEffect(function () {
    StoreActions.stopPollForMessages();
  }, []);
  useRedirectAfterLogin();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [config.userLanguageEnabled && /*#__PURE__*/_jsx(LanguageSwitcher, {}), /*#__PURE__*/_jsx(CenterContent, {
      contentWidth: width,
      height: "100%",
      p: ['xs', 'm']
      // Spacing for the language selector
      ,
      pt: 45,
      breakpoints: "xs",
      children: /*#__PURE__*/_jsx(Card, {
        variant: "raised",
        children: children
      })
    }), /*#__PURE__*/_jsx(AlertRenderer, {})]
  });
}
export default AuthPageWrapper;